import getNoOptionsMessage from './getNoOptionsMessage';

export default getNoOptionsMessage;
